"use client"

import { cn } from "@/lib/utils"

interface ChatBubbleProps {
  role: "bot" | "user"
  children: React.ReactNode
}

export function ChatBubble({ role, children }: ChatBubbleProps) {
  const isUser = role === "user"
  return (
    <div className={cn("flex", isUser ? "justify-end" : "justify-start")}>
      <div
        className={cn(
          "max-w-[85%] rounded-md px-3 py-2 text-[13px] whitespace-pre-wrap",
          isUser ? "text-white" : "bg-gray-100 text-gray-900"
        )}
        style={isUser ? { background: "#193144" } : undefined}
      >
        {children}
      </div>
    </div>
  )
}

export function TypingIndicator() {
  return (
    <div className="flex justify-start">
      <div className="bg-gray-100 rounded-md px-3 py-2">
        <div className="flex gap-1 items-center h-5">
          {[0, 1, 2].map(i => (
            <span
              key={i}
              className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce"
              style={{ animationDelay: `${i * 150}ms` }}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
